import { render, staticRenderFns } from "./MoniteurExpert.vue?vue&type=template&id=2c15710c&scoped=true"
import script from "./MoniteurExpert.vue?vue&type=script&lang=js"
export * from "./MoniteurExpert.vue?vue&type=script&lang=js"
import style0 from "./MoniteurExpert.vue?vue&type=style&index=0&id=2c15710c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15710c",
  null
  
)

export default component.exports